import { render, staticRenderFns } from "./Seleccion.vue?vue&type=template&id=292429e3&scoped=true&"
import script from "./Seleccion.vue?vue&type=script&lang=js&"
export * from "./Seleccion.vue?vue&type=script&lang=js&"
import style0 from "./Seleccion.vue?vue&type=style&index=0&id=292429e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292429e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
